/*
Controller: ChangePassword

Operations:
  changePassword
*/
var Api = require('../config')
var ChangePasswordDef = require('../definitions/ChangePassword')

var ChangePassword = (function () {
  /*
  Operation: changePassword
  change password from the foundry platform
  Parameters:
    bodyRequest: change password object
  Responses:
    HTTP 200: Valid response
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function changePasswordChangePassword (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        ChangePasswordDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/changePassword'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['changePassword'] = changePasswordChangePassword
  return ret
})()

module.exports = ChangePassword
